import * as React from "react";
import { forwardRef } from "react";
import { chakra, useStyleConfig } from "@chakra-ui/react";
export const RedoIcon = forwardRef(({ baseline = false, ...props }, ref) => {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return React.createElement(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props },
        React.createElement("path", { d: "M18.677 13.794a.5.5 0 0 1-.5.5h-4.293a.5.5 0 0 1-.353-.854l1.481-1.481c-2.62-1.691-6.437-1.159-8.304 1.597-.267.393-.77.584-1.204.39-.452-.203-.65-.745-.383-1.163 2.44-3.81 7.682-4.5 11.135-2.068l1.568-1.568a.5.5 0 0 1 .853.354v4.293Z" }));
});
RedoIcon.displayName = "RedoIcon";
